/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Isir_Ico_HintInputs */

const cs_property_registry_isir_ico_hint = /** @type {(inputs: Property_Registry_Isir_Ico_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použije IČO z pole ARES, pokud je vyplněné.`)
};

const en_property_registry_isir_ico_hint = /** @type {(inputs: Property_Registry_Isir_Ico_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uses the IČO from the ARES field when filled.`)
};

/**
* | output |
* | --- |
* | "Uses the IČO from the ARES field when filled." |
*
* @param {Property_Registry_Isir_Ico_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_isir_ico_hint = /** @type {((inputs?: Property_Registry_Isir_Ico_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Isir_Ico_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_isir_ico_hint(inputs)
	return cs_property_registry_isir_ico_hint(inputs)
});